module.exports = __webpack_public_path__ + "static/media/tumblr.683fc72b.png";